import React from "react";

const capitalizeWords = (string) => {
	return string.toLowerCase().split(" ").map(word =>
		word.charAt(0).toUpperCase() + word.slice(1)
	).join(" ");
};

const HighlightMatch = ({ text, query }) => {
	if (!query) return text;

	const capitalizedText = capitalizeWords(text);

	const escapeRegex = (str) => str.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
	const regex = new RegExp(`(${escapeRegex(query)})`, "gi");

	return capitalizedText.split(regex).map((part, index) =>
		regex.test(part)
			? <strong key={index} className="font-bold">{part}</strong>
			: part

	);
};

export default HighlightMatch;
